import { apiGateway } from '../api';

async function situacoes() {
    try {
        const response = await apiGateway.get('/aposentadosdemitidos/situacoes');

        return response.data;
    } catch (error) {
        return error;
    }
}

async function periodoBeneficio(param) {
    try {
        const response = await apiGateway.get(`/aposentadosdemitidos/periodobeneficio?${param}`);

        return response.data;
    } catch (error) {
        return error;
    }
}

const getDateEmployeeTermination = async (carteirinha) => {
    try {
        const response = await apiGateway.get(
            `/api/TopDownMovimentacaoCadastralApi/api/v0/aposentadosdemitidos/sugestaoinatividade?numeroAssociadoOuNumeroCarteira=${carteirinha}`,
        );

        return response.data.results.dataInicioInatividade;
    } catch (error) {
        return false;
    }
}

export { situacoes, periodoBeneficio, getDateEmployeeTermination };
